const navigateToPageNumberHref = (
  currentUrl: string,
  pageNumber: number,
): string => {
  if (Number.isNaN(pageNumber) || pageNumber < 1) {
    return "";
  }

  const formerUrl = currentUrl && currentUrl.length ? currentUrl : "";
  const searchIndex = currentUrl.indexOf("?");
  const urlPath =
    searchIndex >= 0 ? currentUrl.substring(0, searchIndex) : currentUrl;
  const nonPagingSearchParts =
    searchIndex >= 0
      ? currentUrl
          .substring(searchIndex)
          .replace("?", "")
          .split("&")
          .filter((part) => part.length > 0 && !part.startsWith("page="))
      : [];
  const newSearchParts =
    pageNumber > 1
      ? nonPagingSearchParts.concat([`page=${pageNumber}`])
      : nonPagingSearchParts;
  const newSearch = newSearchParts.length ? `?${newSearchParts.join("&")}` : "";
  const newUrl = `${urlPath}${newSearch}`;

  return newUrl.toLowerCase() !== formerUrl.toLowerCase() ? newUrl : "";
};

export default navigateToPageNumberHref;
